import { supabase } from './supabase'

const SESSION_KEY = 'limitlast-session-id'

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(SESSION_KEY, id)
  }
  return id
}

function getDeviceType(): string {
  const width = window.innerWidth
  if (width < 768) return 'mobile'
  if (width < 1024) return 'tablet'
  return 'desktop'
}

// No IP lookups are made — this is a rough guess from the browser's own
// locale setting (e.g. "en-US" -> "US"), not authoritative geolocation.
function getCountryGuess(): string | null {
  const locale = navigator.languages?.[0] ?? navigator.language
  const region = locale?.split('-')[1]
  return region ? region.toUpperCase() : null
}

export async function logPageView(pagePath: string) {
  try {
    await supabase.from('page_views').insert({
      page_path: pagePath,
      referrer: document.referrer || null,
      country: getCountryGuess(),
      device_type: getDeviceType(),
      session_id: getSessionId(),
    })
  } catch {
    // Analytics should never break the site for visitors.
  }
}
